define('common/views/datepicker',['require','exports','module','base/itemview','i18n','datepicker','ldsh!../templates/datepicker'],function (require, exports, module) {
  'use strict';

  var ItemView = require('base/itemview'),
    i18n = require('i18n');

  //require("picker");
  require('datepicker');

  module.exports = ItemView.extend({
    template: require('ldsh!../templates/datepicker'),

    events: {
      'click button': 'setValues',
    },

    helpers: function () {
      return {
        buttonText: this.i18n.buttonText,
        titleText: this.i18n.titleText,
        showButton: this._showButton,
        showLabel: this._showLabel,
      };
    },

    initialize: function (options) {
      options = options || {};
      if (options.viewToggler) {
        options.viewToggler.on('datepicker:toggle', _.bind(this.toggle, this));
      }
      this._showButton = !options.noButton;
      this._showLabel = !options.noLabel;
      this.listenTo(this.model, 'invalid', this.showError);
      this.i18n = {
        titleText: i18n.t(options.titleTranslationKey || 'landingPage.datepicker.title'),
        buttonText: i18n.t(options.buttonTranslationKey || 'landingPage.datepicker.filterButton'),
        errorText: i18n.t('landingPage.datepicker.errorText'),
        unchangedDate: i18n.t('landingPage.datepicker.unchangedDate'),
        badRange: i18n.t('landingPage.datepicker.badRange'),
      };
      this.toggle(!!this.model.hasChanged());
    },

    _getDefaultConfiguration: function (name) {
      var months = _.values($.i18n.t('datepicker.months', { returnObjectTrees: true })),
        weekdaysShort = _.values($.i18n.t('datepicker.weekdaysShort', { returnObjectTrees: true }));
      return {
        format: $.i18n.t('datepicker.date' + name) + ' dd/mm/yyyy',
        formatSubmit: 'yyyy/mm/dd',
        hiddenName: true,
        monthsFull: months,
        weekdaysShort: weekdaysShort,
        firstDay: 1,
        today: $.i18n.t('datepicker.today'),
        clear: false,
        close: false,
        labelMonthNext: $.i18n.t('datepicker.labelMonthNext'),
        labelMonthPrev: $.i18n.t('datepicker.labelMonthPrev'),
        labelMonthSelect: $.i18n.t('datepicker.labelMonthSelect'),
        labelYearSelect: $.i18n.t('datepicker.labelYearSelect'),
      };
    },

    getPickadate: function (name) {
      return this.$('input[name=' + name + '_date]');
    },

    computeDateLimits: function (name, date) {
      function date2arr(date) {
        var arr = date.split('/').map(function (part) {
            return +part;
          }),
          year = arr[0],
          month = arr[1],
          day = arr[2],
          zeroIndexedMonth = month - 1;
        return [year, zeroIndexedMonth, day];
      }
      var limits = {
        from: [
          {
            name: 'max',
            prop: 'to',
          },
        ],
        to: [
          {
            name: 'max',
            value: true,
          },
          {
            name: 'min',
            prop: 'from',
          },
        ],
      }[name];
      return _.reduce(
        limits,
        function (limits, limit) {
          limits[limit.name] = limit.value || date2arr(date || this.model.get(limit.prop));
          return limits;
        },
        {},
        this
      );
    },

    invalidateDatesFor: function (name, date) {
      var picker = name === 'from' ? 'to' : 'from',
        limits = this.computeDateLimits(picker, date);
      this[picker].pickadate('picker').set(limits).render();
    },

    setValues: function (e) {
      e && e.preventDefault();
      var dates = {},
        dateFrom = this.getPickadate('from').val(),
        dateTo = this.getPickadate('to').val();
      dates.from = dateFrom;
      dates.to = dateTo;
      this.invalidateDatesFor('from', dateFrom);
      this.invalidateDatesFor('to', dateTo);
      this.model.set(dates, { validate: true });
      this.model.trigger('setValues');
    },

    setValue: function (name, e) {
      e && e.preventDefault();
      var dates = {},
        date = this.getPickadate(name).val();
      dates[name] = date;
      this.invalidateDatesFor(name, date);
      this.model.set(dates, { validate: true });
      this.model.trigger('setValue');
    },

    clearError: function () {
      this.$('input').parent().removeClass('has-error');
    },

    showError: function (dateModel, errors) {
      _.each(
        errors,
        function (error) {
          this.$('.' + error.selector)
            .parent()
            .addClass('has-error');
          this.$('.' + error.selector + '-error').text(this.i18n[error.errorKey]);
        },
        this
      );
    },

    onRender: function () {
      ['from', 'to'].forEach(this.renderPicker, this);
      this.$el.i18n();
    },

    renderPicker: function (name) {
      this[name] = this.getPickadate(name).pickadate(
        _.extend(this._getDefaultConfiguration(name), this.computeDateLimits(name), {
          onOpen: _.bind(this.clearError, this, name),
          onClose: _.bind(this.setValue, this, name),
        })
      );
      this.renderPickerHeader(name);
    },

    renderPickerHeader: function (name) {
      var pickadateSelector = '.js-' + name + '-date',
        pickadateHeaderSelector = pickadateSelector + ' + div .picker__wrap',
        pickadate = this.$(pickadateSelector).pickadate('picker'),
        pickerHeader =
          '<div class="picker-heading"><div class="picker-heading-wrapper"><p class="title" data-i18n="landingPage.datepicker.select">Selecciona</p><button class="close">x</button></div></div>',
        closePicker = $(pickerHeader).on('click', _.bind(pickadate.close, pickadate));
      this.$(pickadateHeaderSelector).prepend(closePicker);
    },

    toggle: function (isVisible) {
      this.$el.toggleClass('hidden', typeof isVisible === 'boolean' ? !isVisible : undefined);
    },

    toString: function () {
      return [
        $.i18n.t('datepicker.dateFrom'),
        this.model.get('from'),
        $.i18n.t('datepicker.dateTo'),
        this.model.get('to'),
      ].join(' ');
    },
  });
});

